export const EXCERPT_META_SELECTORS = [
  'og:description',
  'twitter:description',
];
